// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1FcuP","title":"AfterFrontImage_title__39hse"};